<template>
  <div v-loading="showFlag">
    <t-card class="card_common">
      <!-- 担当者別の年間見積、受注実績レポート画面 -->
      <div class="annualNumberAndAcceptByUserReportForm">
        <t-form label-position="right" label-width="100px">
          <t-row
            type="flex"
            justify="left
          "
          >
            <t-col :span="16">
              <div>
                <t-form-item
                  :label="$t('resource.CUS_M_ORDER_AMOUNT.PERIOD')"
                  class="marginBottom"
                >
                  <t-select
                    class="select-year-width"
                    v-model="period.startYear"
                  >
                    <t-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </t-option>
                  </t-select>

                  <t-select
                    class="select-year-width"
                    v-model="period.startMonth"
                  >
                    <t-option
                      v-for="item in monthList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </t-option>
                  </t-select>
                  <span>&nbsp;&nbsp;～&nbsp;&nbsp;</span>
                  <t-select class="select-year-width" v-model="period.endYear">
                    <t-option
                      v-for="item in yearList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </t-option>
                  </t-select>

                  <t-select class="select-year-width" v-model="period.endMonth">
                    <t-option
                      v-for="item in monthList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </t-option>
                  </t-select>
                </t-form-item>
              </div>
            </t-col>

            <t-col :span="4" class="right">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="button_common_search marginRight"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>{{ $t("resource.sys.search") }}
              </t-button>
            </t-col>

            <t-col :span="4" class="right">
              <!-- 報告出力 -->
              <t-button
                round
                type="primary"
                ref="outPut"
                class="button_common_search marginRight"
                @click="outPutClick()"
              >
                <i class="el-icon-download"></i
                >{{ $t("resource.REPORT.REPORT_OUT") }}
              </t-button>
            </t-col>
          </t-row>
          <t-row>
            <t-table
              :data="annualNumberAndAcceptByUserList"
              tooltip-effect="dark"
              style="width: 100%"
              header-cell-class-name="bg-default"
              :max-height="maxheight"
              :span-method="handleSpanMethod"
              highlight-current-row
              border
            >
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="department"
                :label="
                  $t('resource.ANNUAL_NUMBER_AND_ACCEPT_BY_USER.DEPARTMENT')
                "
              ></t-table-column>
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="userName"
                :label="
                  $t('resource.ANNUAL_NUMBER_AND_ACCEPT_BY_USER.USER_NAME')
                "
              ></t-table-column>
              <t-table-column
                v-if="periodMonthList.length"
                fixed
                width="100"
                prop="kbn"
                class-name="cell_txt_center"
                :label="$t('resource.ANNUAL_NUMBER_AND_ACCEPT_BY_USER.KBN')"
              ></t-table-column>

              <t-table-column
                v-for="(column, index) in periodMonthList"
                :key="index"
                :label="column.title"
                min-width="100"
                class-name="cell_txt_right"
                ><template #default="scope">
                  <!-- UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓ -->
                  <!-- <span>{{ scope.row.dicCount["count" + (index + 1)] }}</span> -->

                  <t-input
                    v-if="editCellData(scope.row) == 'input'"
                    class="cell_input_custom"
                    :controls="false"
                    :maxlength="9"
                    :disabled="disabledCheck(scope.row)"
                    v-model="scope.row.dicCount['count' + (index + 1)]"
                    @input="
                      scope.row.dicCount['count' + (index + 1)] =
                        scope.row.dicCount['count' + (index + 1)].replace(
                          /[^\d]/g,
                          ''
                        )
                    "
                    @change="changeCellData(scope.$index, index)"
                    :ref="`input-${scope.$index}-${index}`"
                    @keyup.native.enter="focusNextInput(scope.$index, index)"
                  ></t-input>

                  <t-input-number
                    v-else-if="editCellData(scope.row) == 'inputNumber'"
                    class="cell_input_number"
                    :controls="false"
                    :precision="0"
                    :min="0"
                    :max="999999999"
                    :disabled="disabledCheck(scope.row)"
                    :value="scope.row.dicCount['count' + (index + 1)]"
                    :ref="`input-${scope.$index}-${index}`"
                    @focus="selectValue($event)"
                    @keyup.native.enter="focusNextInput(scope.$index, index)"
                    @change="changeCellData(scope.$index, index, $event)"
                  ></t-input-number>
                  <!-- UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑ -->
                </template>
              </t-table-column>
            </t-table>
          </t-row>

          <!-- ADD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓ -->
          <t-row
            ><t-col :span="20" class="right">&nbsp;</t-col>
            <t-col :span="4" class="right">
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="quoteConfirm"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>
          </t-row>
          <!-- ADD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑ -->
        </t-form>
      </div>
    </t-card>
  </div>
</template>
<script>
import { httpApi } from "@/api/api";
import { t } from "@/locales";
import {
  SearchAnnualNumberAndAcceptByUserData,
  updateAnnualNumberAndAcceptData,
} from "@/services/annualNumberAndAcceptByUserReport";
import { outputExcelToZip } from "@/services/common";
import { Message } from "@tellus/component";
import { Row } from "@tellus/ui";
import { NUM_ZERO, STR_COLON, STR_HYPHEN, STR_PERCENT } from "@/utils/const";
export default {
  data() {
    return {
      // UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      //一覧高
      //maxheight: window.innerHeight - 140,
      maxheight: window.innerHeight - 180,
      // UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
      //期間年度
      yearList: [],
      //期間月度
      monthList: [],
      //期間値
      period: {
        startYear: "",
        startMonth: "",
        endYear: "",
        endMonth: "",
      },
      //期間月度
      periodMonthList: [],
      //件数データ
      annualNumberAndAcceptByUserList: [],

      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      //個人受注実績の見積件数データ(更新用)
      annualNumberOutList: [],

      //合計行数
      totalRowNum: 0,
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
      //月度差
      monthsDiff: 0,
      showFlag: false,
    };
  },

  mounted() {
    this.init();

    this.$nextTick(() => {
      // UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      //this.maxheight = window.innerHeight - 140;
      this.maxheight = window.innerHeight - 180;
      // UPD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
    });
  },

  computed: {},

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      //システム日
      var systemDate = new Date();
      //システム年
      var systemYear = systemDate.getFullYear();
      //システム月
      var systemMonth = systemDate.getMonth();

      //年度リスト
      for (let year = 2024; year <= systemYear + 1; year++) {
        this.yearList.push({
          value: year,
          label: year + t("resource.CUS_M_ORDER_AMOUNT.YEAR"),
        });
      }

      //月度リスト
      for (let month = 1; month <= 12; month++) {
        this.monthList.push({
          value: month,
          label: month + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
        });
      }

      //期間の初期値
      //システム月
      if (systemMonth <= 3) {
        //開始年度
        this.period.startYear = systemYear - 1;
        //終了年度
        this.period.endYear = systemYear;
      } else {
        //開始年度
        this.period.startYear = systemYear;
        //終了年度
        this.period.endYear = systemYear + 1;
      }

      //開始月度
      this.period.startMonth = 4;
      //終了月度
      this.period.endMonth = 3;
      //検索
      this.searchClick();
    },

    // 検索
    searchClick() {
      //チェック
      //月度差
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      SearchAnnualNumberAndAcceptByUserData({
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
      })
        .then((res) => {
          // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
          this.annualNumberAndAcceptByUserList = [];
          // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

          //期間月度
          this.periodMonthList.length = 0;
          let month = this.period.startMonth;
          // UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
          // for (let i = 0; i <= this.monthsDiff; i++) {
          //   if (parseInt(month) + i <= 12) {
          //     this.periodMonthList.push({
          //       title:
          //         parseInt(month) + i + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
          //     });
          //   } else {
          //     this.periodMonthList.push({
          //       title:
          //         parseInt(month) +
          //         i -
          //         12 +
          //         t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
          //     });
          //   }
          //開始年月
          let year = this.period.startYear;
          //月度値
          let monthValue;
          //年月
          let yearMonth;
          for (let i = 0; i <= this.monthsDiff; i++) {
            if (parseInt(month) + i <= 12) {
              //月度値
              monthValue = parseInt(month) + i;
              //年月
              if (monthValue < 10) {
                yearMonth = year + "_0" + monthValue;
              } else {
                yearMonth = year + "_" + monthValue;
              }
            } else {
              //月度値
              monthValue = parseInt(month) + i - 12;
              //年月
              if (monthValue < 10) {
                yearMonth = year + 1 + "_0" + monthValue;
              } else {
                yearMonth = year + 1 + "_" + monthValue;
              }
            }
            // 期間月リスト（echarts用）
            this.periodMonthList.push({
              title: monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
              yearMonth: yearMonth,
            });
          }
          // UPD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

          //件数データ
          this.annualNumberAndAcceptByUserList =
            res.annualNumberAndAcceptByUserList;
          this.getBgSpanArr(this.annualNumberAndAcceptByUserList);
          this.showFlag = false;
        })
        .catch((err) => {
          this.showFlag = false;
          Message.showError(
            t("message.CUS_M_ORDER_AMOUNT.SEARCH_FAILURE"),
            null
          );
        });
    },

    outPutClick() {
      this.monthsDiff =
        (this.period.endYear - this.period.startYear) * 12 -
        parseInt(this.period.startMonth) +
        parseInt(this.period.endMonth);

      if (this.monthsDiff < 0) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.DATE_COMPARE_MSG"),
          null
        );
        return;
      }

      if (this.monthsDiff >= 12) {
        this.showFlag = false;
        Message.showError(
          t("message.CUS_M_ORDER_AMOUNT.MONTHS_DIFF_MSG"),
          null
        );
        return;
      }

      this.showFlag = true;

      //期間月度
      let monthList = [];
      //開始年月
      let year = this.period.startYear;
      let month = this.period.startMonth;
      //月度値
      let monthValue;
      //年月
      let yearMonth;
      for (let i = 0; i <= this.monthsDiff; i++) {
        if (parseInt(month) + i <= 12) {
          //月度値
          monthValue = parseInt(month) + i;
          //年月
          if (monthValue < 10) {
            yearMonth = year + "_0" + monthValue;
          } else {
            yearMonth = year + "_" + monthValue;
          }
        } else {
          //月度値
          monthValue = parseInt(month) + i - 12;
          //年月
          if (monthValue < 10) {
            yearMonth = year + 1 + "_0" + monthValue;
          } else {
            yearMonth = year + 1 + "_" + monthValue;
          }
        }

        monthList.push({
          title: monthValue + t("resource.CUS_M_ORDER_AMOUNT.MONTH"),
          yearMonth: yearMonth,
        });
      }

      outputExcelToZip(httpApi.OutAnnualNumberAndAcceptByExcel, {
        searchStartYearMonth:
          this.period.startYear + "/" + this.period.startMonth,
        searchEndYearMonth: this.period.endYear + "/" + this.period.endMonth,
        titleDtos: monthList,
      })
        .then((res) => {
          //検索
          this.searchClick();
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    // 一覧表行目結合
    handleSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1,
        };
      }
      if (columnIndex === 1) {
        return {
          rowspan: row.rowspansecond,
          colspan: 1,
        };
      }
    },

    //一覧表行目結合データの取得
    getBgSpanArr(list) {
      let firstIndex = 0;
      let firstItem = "";
      let secondIndex = 0;
      let secondItem = "";

      //
      for (let i = 0; i < list.length; i++) {
        list[i].rowspan = 1;
        list[i].rowspansecond = 1;

        //部門コードの比較
        if (list[i].departmentCode == firstItem) {
          list[firstIndex].rowspan++;
          list[i].rowspan = 0;
        } else {
          firstIndex = i;
          firstItem = list[i].departmentCode;
        }

        //ユーザーIDの比較
        if (list[i].userId == secondItem) {
          list[secondIndex].rowspansecond++;
          list[i].rowspansecond = 0;
        } else {
          secondIndex = i;
          secondItem = list[i].userId;
        }
      }
      this.annualNumberAndAcceptByUserList = list;
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (
          element.department.includes(
            t("resource.ANNUAL_ORDER_PERFORM.TOTAL")
          ) &&
          element.userName.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL")) &&
          element.kbn.includes(t("resource.ANNUAL_ORDER_PERFORM.QUOTE_COUNTS"))
        ) {
          //合計の行数を取得
          this.totalRowNum = index;
        }
      }
      // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
    },

    // ADD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
    //入力ボックスをクリックできるかどうか
    disabledCheck(row) {
      //見積件数の場合、入力可能
      if (
        row.kbn.includes(t("resource.ANNUAL_ORDER_PERFORM.QUOTE_COUNTS")) &&
        !row.department.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL")) &&
        !row.userName.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL"))
      ) {
        return false;
      }

      return true;
    },

    //Enter処理
    focusNextInput(index, column) {
      index = index + 1;

      if (index > this.annualNumberAndAcceptByUserList.length - 1) {
        for (var i = 5; i < this.annualNumberAndAcceptByUserList.length; i++) {
          var tmpIndex = this.$refs[`input-${i}-${column}`].length - 1;
          if (
            this.$refs[`input-${i}-${column}`] !== undefined &&
            !this.$refs[`input-${i}-${column}`][tmpIndex].disabled
          ) {
            this.$refs[`input-${i}-${column}`][tmpIndex].focus();

            break;
          }
        }
      } else {
        for (
          var i = index;
          i < this.annualNumberAndAcceptByUserList.length;
          i++
        ) {
          var tmpIndex = this.$refs[`input-${i}-${column}`].length - 1;
          if (
            this.$refs[`input-${i}-${column}`] !== undefined &&
            !this.$refs[`input-${i}-${column}`][tmpIndex].disabled
          ) {
            this.$refs[`input-${i}-${column}`][tmpIndex].focus();

            break;
          }
        }
        //下に入力ボックスがない場合は、最初から
        if (i == this.annualNumberAndAcceptByUserList.length) {
          this.focusNextInput(-1, column);
        }
      }
    },

    //確定ボタン
    quoteConfirm() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      this.showFlag = true;
      this.annualNumberOutList.length = 0;
      let quoteNumberDataList = this.annualNumberAndAcceptByUserList.filter(
        (item) =>
          item.kbn.includes(t("resource.ANNUAL_ORDER_PERFORM.QUOTE_COUNTS")) &&
          !item.department.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL")) &&
          !item.userName.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL"))
      );

      for (let index = 0; index < quoteNumberDataList.length; index++) {
        const element = quoteNumberDataList[index];
        for (let colNum = 0; colNum < this.periodMonthList.length; colNum++) {
          //データの作成
          this.annualNumberOutList.push({
            rqcUserCode: element.userId, // 担当者コード
            rqcYearMonth: this.periodMonthList[colNum].yearMonth, //年月
            rqcQuoteCount:
              element.dicCount["count" + (colNum + 1)] === null
                ? 0
                : element.dicCount["count" + (colNum + 1)], //見積件数
          });
        }
      }

      updateAnnualNumberAndAcceptData({
        annualQuoteNumberList: this.annualNumberOutList,
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON.UPDATE_SUCCESS"));
        })
        .catch((err) => {
          Message.showError(t("message.COMMON.UPDATE_FAILURE"), null);
        })
        .finally(() => {
          this.showFlag = false;
          this.searchClick();
        });
    },

    // ADD 2024/12/16 Wzc 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑

    // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 start↓
    changeCellData(rowNum, colNum, newValue) {
      this.$set(
        this.annualNumberAndAcceptByUserList[rowNum].dicCount,
        "count" + (colNum + 1),
        newValue
      );

      this.$nextTick(() => {
        let colName = "count" + (colNum + 1);
        // 見積件数
        let quoteNum;

        // 受注率
        let orderRateRowNum = rowNum + 2;

        // 受注件数
        let orderNumberRowNum = rowNum + 1;
        let orderNumber;

        // 空の場合、値が「0」を設定
        this.annualNumberAndAcceptByUserList[rowNum].dicCount[colName] =
          this.isEmpty(
            this.annualNumberAndAcceptByUserList[rowNum].dicCount[colName]
          );

        // 見積件数
        quoteNum =
          this.annualNumberAndAcceptByUserList[rowNum].dicCount[colName];
        // 受注件数
        orderNumber =
          this.annualNumberAndAcceptByUserList[orderNumberRowNum].dicCount[
            colName
          ];

        // 受注率を更新
        this.annualNumberAndAcceptByUserList[orderRateRowNum].dicCount[
          colName
        ] =
          this.isEmpty(orderNumber) != 0 && quoteNum != 0
            ? parseInt((orderNumber * 100) / quoteNum) + STR_PERCENT
            : STR_HYPHEN;

        this.updateTotalData(colName);
      });
    },

    // 合計のデータを更新
    updateTotalData(colName) {
      // 見積数合計
      let totalQuoteNumber = 0;
      let totalQuoteRowNum = this.totalRowNum;
      for (
        let index = 0;
        index < this.annualNumberAndAcceptByUserList.length;
        index++
      ) {
        const element = this.annualNumberAndAcceptByUserList[index];

        if (
          element.kbn.includes(
            t("resource.ANNUAL_ORDER_PERFORM.QUOTE_COUNTS")
          ) &&
          !element.department.includes(
            t("resource.ANNUAL_ORDER_PERFORM.TOTAL")
          ) &&
          !element.userName.includes(t("resource.ANNUAL_ORDER_PERFORM.TOTAL"))
        ) {
          totalQuoteNumber += this.isEmpty(parseInt(element.dicCount[colName]));
        }
      }
      //合計の見積数を更新
      this.annualNumberAndAcceptByUserList[totalQuoteRowNum].dicCount[colName] =
        totalQuoteNumber;

      //合計の受注率を更新
      this.annualNumberAndAcceptByUserList[totalQuoteRowNum + 2].dicCount[
        colName
      ] =
        this.isEmpty(
          this.annualNumberAndAcceptByUserList[totalQuoteRowNum + 1].dicCount[
            colName
          ]
        ) != 0 &&
        this.isEmpty(
          this.annualNumberAndAcceptByUserList[totalQuoteRowNum].dicCount[
            colName
          ]
        ) != 0
          ? parseInt(
              (this.annualNumberAndAcceptByUserList[totalQuoteRowNum + 1]
                .dicCount[colName] *
                100) /
                this.annualNumberAndAcceptByUserList[totalQuoteRowNum].dicCount[
                  colName
                ]
            ) + STR_PERCENT
          : STR_HYPHEN;
    },

    // 空のチェック
    isEmpty(num) {
      if (isNaN(num) || num == null || !num) {
        return NUM_ZERO;
      }
      return num;
    },

    // 入力ボックスをクリックの場合、値をすべて選択します
    selectValue(e) {
      e.target.select();
    },

    //セルの編集
    editCellData(row) {
      if (row.kbn === t("resource.ANNUAL_ORDER_PERFORM.ORDER_RATE")) {
        return "input";
      } else {
        return "inputNumber";
      }
    },
    // ADD 2024/12/16 ZLL 課題(#32906)_個人受注実績の見積件数が入力可能に変更 end↑
  },
};
</script>
